import { lazyWithRetry } from 'utils/chunkLoadRecovery';

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/pages/errors/error-404',
      component: lazyWithRetry(() => import('app/pages/errors/404/Error404Page')),
    },
  ],
};

export default routesConfig;
